<template>
  <div class="review-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="1340"
      top="60px"
      :show-close="true"
      :before-close="handleClose">
      <div slot="title" class="header">
        <p class="title">{{ reviewObj.panelName }}</p>
        <div class="header-actions">
          <el-button
            v-if="canDeleteTemplate"
            type="text"
            title="删除模版"
            class="btn-delete"
            :loading="deleteLoading"
            @click="handleDeleteTemplate">
            删除
          </el-button>
          <el-button type="primary" class="btn" :loading="btnLoading" @click="handleSubmit">应用</el-button>
        </div>
      </div>
      <div class="container">
        <el-image
          :src="reviewObj.panelThumbnail"
          fit="contain"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveScreenApi, deleteTemplateApi } from '../fetch'
export default {
  name: 'ReviewDialog',
  components: {
  },
  props: {
    reviewObj: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      dialogVisible: true,
      btnLoading: false,
      deleteLoading: false,
    }
  },
  computed: {
    deleteTemplateId () {
      const o = this.reviewObj || {}
      const id = o.templateId !== undefined && o.templateId !== null ? o.templateId : o.screenTemplateId
      if (id === undefined || id === null || id === '') return null
      return id
    },
    canDeleteTemplate () {
      return this.deleteTemplateId != null && this.deleteTemplateId !== ''
    },
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        this.btnLoading = true
        const panelInfo = await saveScreenApi(this.reviewObj)
        this.$success('操作成功')
        this.dialogVisible = false
        this.$router.push({
          path: `/screen/edit/${panelInfo.panelSn}`,
        })
        this.$emit('close')
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
    async handleDeleteTemplate () {
      const id = this.deleteTemplateId
      if (id == null || id === '') return
      try {
        await this.$confirm('确定删除该模版吗？删除后不可恢复。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
      } catch (e) {
        return
      }
      try {
        this.deleteLoading = true
        await deleteTemplateApi(id)
        this.$success('删除成功')
        this.dialogVisible = false
        this.$emit('deleted')
        this.$emit('close')
      } catch (e) {
        this.$error(e)
      } finally {
        this.deleteLoading = false
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.review-dialog{
  .container{
    width: 100%;
    height: 754px;
    padding: 4% 0 2%;
  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    top: 0;
    left: 0;
    right: 0;
  }
  ::v-deep .el-dialog{
    position: relative;
    background: none;
    box-shadow: none;
    width: 100%;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .el-image{
      height: 100%;
      width: 100%;
    }
    .el-image__error{
      background: none;
      color: #FFF;
    }
    .el-dialog__header{
      z-index: 2002;
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding: 0 40px 0 30px !important;
      background-color: #000000;
      color: #FFF;
      position: fixed;
      top: 0;
      .header{
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header-actions{
          display: flex;
          align-items: center;
          gap: 8px;
          margin-right: 30px;
        }
        .btn-delete{
          color: rgba(255, 255, 255, 0.45);
          padding: 6px !important;
          min-width: 32px !important;
          &:hover{
            color: #ff7875;
          }
          ::v-deep i{
            font-size: 16px;
          }
        }
        .btn{
          color: #FFF;
          font-size: 14px !important;
          height: 34px;
        }
      }
      .el-dialog__headerbtn{
        width: 24px;
        height: 24px;
        background: #E8E8E8;
        border-radius: 50%;
      }
    }
    .el-dialog__body{
      overflow: auto;
      width: 100%
    }
  }

}
</style>
